function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var Et = Object.create;
var Ye = Object.defineProperty;
var bt = Object.getOwnPropertyDescriptor;
var gt = Object.getOwnPropertyNames;
var yt = Object.getPrototypeOf,
  wt = Object.prototype.hasOwnProperty;
var Lt = function Lt(n, e) {
  return function () {
    return e || n((e = {
      exports: {}
    }).exports, e), e.exports;
  };
};
var Pt = function Pt(n, e, r, i) {
  if (e && _typeof(e) == "object" || typeof e == "function") {
    var _iterator = _createForOfIteratorHelper(gt(e)),
      _step;
    try {
      var _loop = function _loop() {
        var o = _step.value;
        !wt.call(n, o) && o !== r && Ye(n, o, {
          get: function get() {
            return e[o];
          },
          enumerable: !(i = bt(e, o)) || i.enumerable
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return n;
};
var St = function St(n, e, r) {
  return r = n != null ? Et(yt(n)) : {}, Pt(e || !n || !n.__esModule ? Ye(r, "default", {
    value: n,
    enumerable: !0
  }) : r, n);
};
var je = Lt(function (he, Je) {
  (function (n, e) {
    _typeof(he) == "object" && _typeof(Je) < "u" ? e(he) : typeof define == "function" && define.amd ? define(["exports"], e) : (n = (typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) < "u" ? globalThis : n || self, e(n.fastUniqueNumbers = {}));
  })(he, function (n) {
    "use strict";

    var e = function e(l) {
        return function (p) {
          var f = l(p);
          return p.add(f), f;
        };
      },
      r = function r(l) {
        return function (p, f) {
          return l.set(p, f), f;
        };
      },
      i = Number.MAX_SAFE_INTEGER === void 0 ? 9007199254740991 : Number.MAX_SAFE_INTEGER,
      o = 536870912,
      u = o * 2,
      g = function g(l, p) {
        return function (f) {
          var B = p.get(f),
            y = B === void 0 ? f.size : B < u ? B + 1 : 0;
          if (!f.has(y)) return l(f, y);
          if (f.size < o) {
            for (; f.has(y);) y = Math.floor(Math.random() * u);
            return l(f, y);
          }
          if (f.size > i) throw new Error("Congratulations, you created a collection of unique numbers which uses all available integers!");
          for (; f.has(y);) y = Math.floor(Math.random() * i);
          return l(f, y);
        };
      },
      O = new WeakMap(),
      W = r(O),
      m = g(W, O),
      a = e(m);
    n.addUniqueNumber = a, n.generateUniqueNumber = m;
  });
});
import { Component as Mt, forwardRef as Rt } from "react";
import { jsx as At } from "react/jsx-runtime";
function kt(n) {
  return /*#__PURE__*/Rt(function (r, i) {
    var o = _objectSpread({}, r),
      u = se(o);
    return typeof i == "function" ? i(u) : i && (i.current = u), At(n, _objectSpread(_objectSpread({}, r), u));
  });
}
var Re = /*#__PURE__*/function (_Mt) {
    _inherits(Re, _Mt);
    function Re() {
      _classCallCheck(this, Re);
      return _callSuper(this, Re, arguments);
    }
    return _createClass(Re);
  }(Mt),
  ke = /*#__PURE__*/function (_Re) {
    _inherits(ke, _Re);
    function ke(e) {
      var _this;
      _classCallCheck(this, ke);
      _this = _callSuper(this, ke, [e]), _this.onPresenceChange && e.setOnPresenceChange(_this.onPresenceChange.bind(_assertThisInitialized(_this))), _this.onPrompt && e.setOnPrompt(_this.onPrompt.bind(_assertThisInitialized(_this))), _this.onIdle && e.setOnIdle(_this.onIdle.bind(_assertThisInitialized(_this))), _this.onActive && e.setOnActive(_this.onActive.bind(_assertThisInitialized(_this))), _this.onAction && e.setOnAction(_this.onAction.bind(_assertThisInitialized(_this))), _this.onMessage && e.setOnMessage(_this.onMessage.bind(_assertThisInitialized(_this)));
      return _this;
    }
    return _createClass(ke);
  }(Re);
import { useEffect as b, useRef as c, useCallback as T, useMemo as Dt } from "react";
var oe = St(je());
var Xe = function Xe(n) {
  return n.method !== void 0 && n.method === "call";
};
var ze = function ze(n) {
  return n.error === null && typeof n.id == "number";
};
var Ke = function Ke(n) {
  var e = new Map([[0, function () {}]]),
    r = new Map([[0, function () {}]]),
    i = new Map(),
    o = new Worker(n);
  return o.addEventListener("message", function (_ref) {
    var m = _ref.data;
    if (Xe(m)) {
      var _m$params = m.params,
        a = _m$params.timerId,
        d = _m$params.timerType;
      if (d === "interval") {
        var l = e.get(a);
        if (typeof l == "number") {
          var p = i.get(l);
          if (p === void 0 || p.timerId !== a || p.timerType !== d) throw new Error("The timer is in an undefined state.");
        } else if (_typeof(l) < "u") l();else throw new Error("The timer is in an undefined state.");
      } else if (d === "timeout") {
        var _l = r.get(a);
        if (typeof _l == "number") {
          var _p = i.get(_l);
          if (_p === void 0 || _p.timerId !== a || _p.timerType !== d) throw new Error("The timer is in an undefined state.");
        } else if (_typeof(_l) < "u") _l(), r["delete"](a);else throw new Error("The timer is in an undefined state.");
      }
    } else if (ze(m)) {
      var _a = m.id,
        _d = i.get(_a);
      if (_d === void 0) throw new Error("The timer is in an undefined state.");
      var _l2 = _d.timerId,
        _p2 = _d.timerType;
      i["delete"](_a), _p2 === "interval" ? e["delete"](_l2) : r["delete"](_l2);
    } else {
      var _a2 = m.error.message;
      throw new Error(_a2);
    }
  }), {
    clearInterval: function clearInterval(m) {
      var a = (0, oe.generateUniqueNumber)(i);
      i.set(a, {
        timerId: m,
        timerType: "interval"
      }), e.set(m, a), o.postMessage({
        id: a,
        method: "clear",
        params: {
          timerId: m,
          timerType: "interval"
        }
      });
    },
    clearTimeout: function clearTimeout(m) {
      var a = (0, oe.generateUniqueNumber)(i);
      i.set(a, {
        timerId: m,
        timerType: "timeout"
      }), r.set(m, a), o.postMessage({
        id: a,
        method: "clear",
        params: {
          timerId: m,
          timerType: "timeout"
        }
      });
    },
    setInterval: function setInterval(m, a) {
      var d = (0, oe.generateUniqueNumber)(e);
      return e.set(d, function () {
        m(), typeof e.get(d) == "function" && o.postMessage({
          id: null,
          method: "set",
          params: {
            delay: a,
            now: performance.now(),
            timerId: d,
            timerType: "interval"
          }
        });
      }), o.postMessage({
        id: null,
        method: "set",
        params: {
          delay: a,
          now: performance.now(),
          timerId: d,
          timerType: "interval"
        }
      }), d;
    },
    setTimeout: function setTimeout(m, a) {
      var d = (0, oe.generateUniqueNumber)(r);
      return r.set(d, m), o.postMessage({
        id: null,
        method: "set",
        params: {
          delay: a,
          now: performance.now(),
          timerId: d,
          timerType: "timeout"
        }
      }), d;
    }
  };
};
var Qe = function Qe(n, e) {
  var r = null;
  return function () {
    if (r !== null) return r;
    var i = new Blob([e], {
        type: "application/javascript; charset=utf-8"
      }),
      o = URL.createObjectURL(i);
    return r = n(o), setTimeout(function () {
      return URL.revokeObjectURL(o);
    }), r;
  };
};
var Ze = "(()=>{\"use strict\";const e=new Map,t=new Map,r=(e,t)=>{let r,o;const i=performance.now();r=i,o=e-Math.max(0,i-t);return{expected:r+o,remainingDelay:o}},o=(e,t,r,i)=>{const s=performance.now();s>r?postMessage({id:null,method:\"call\",params:{timerId:t,timerType:i}}):e.set(t,setTimeout(o,r-s,e,t,r,i))};addEventListener(\"message\",(i=>{let{data:s}=i;try{if(\"clear\"===s.method){const{id:r,params:{timerId:o,timerType:i}}=s;if(\"interval\"===i)(t=>{const r=e.get(t);if(void 0===r)throw new Error('There is no interval scheduled with the given id \"'.concat(t,'\".'));clearTimeout(r),e.delete(t)})(o),postMessage({error:null,id:r});else{if(\"timeout\"!==i)throw new Error('The given type \"'.concat(i,'\" is not supported'));(e=>{const r=t.get(e);if(void 0===r)throw new Error('There is no timeout scheduled with the given id \"'.concat(e,'\".'));clearTimeout(r),t.delete(e)})(o),postMessage({error:null,id:r})}}else{if(\"set\"!==s.method)throw new Error('The given method \"'.concat(s.method,'\" is not supported'));{const{params:{delay:i,now:n,timerId:a,timerType:d}}=s;if(\"interval\"===d)((t,i,s)=>{const{expected:n,remainingDelay:a}=r(t,s);e.set(i,setTimeout(o,a,e,i,n,\"interval\"))})(i,a,n);else{if(\"timeout\"!==d)throw new Error('The given type \"'.concat(d,'\" is not supported'));((e,i,s)=>{const{expected:n,remainingDelay:a}=r(e,s);t.set(i,setTimeout(o,a,t,i,n,\"timeout\"))})(i,a,n)}}}}catch(e){postMessage({error:{message:e.message},id:s.id,result:null})}}))})();";
var ve = Qe(Ke, Ze),
  et = function et(n) {
    return ve().clearInterval(n);
  },
  tt = function tt(n) {
    return ve().clearTimeout(n);
  },
  rt = function rt(n, e) {
    return ve().setInterval(n, e);
  },
  nt = function nt(n, e) {
    return ve().setTimeout(n, e);
  };
var M = ((typeof window === "undefined" ? "undefined" : _typeof(window)) > "u" ? "undefined" : typeof window === "undefined" ? "undefined" : _typeof(window)) == "object";
var I = {
    setTimeout: M ? setTimeout.bind(window) : setTimeout,
    clearTimeout: M ? clearTimeout.bind(window) : clearTimeout,
    setInterval: M ? setInterval.bind(window) : setInterval,
    clearInterval: M ? clearInterval.bind(window) : clearInterval
  },
  ae = {
    setTimeout: nt,
    clearTimeout: tt,
    setInterval: rt,
    clearInterval: et
  };
function Ot() {
  I.setTimeout = setTimeout, I.clearTimeout = clearTimeout, I.setInterval = setInterval, I.clearInterval = clearInterval, ae.setTimeout = setTimeout, ae.clearTimeout = clearTimeout, ae.setInterval = setInterval, ae.clearInterval = clearInterval;
}
function it(n) {
  I.setTimeout = n.setTimeout, I.clearTimeout = n.clearTimeout, I.setInterval = n.setInterval, I.clearInterval = n.clearInterval;
}
var Q = {},
  Ae = /*#__PURE__*/function () {
    function Ae(e) {
      _classCallCheck(this, Ae);
      this.name = void 0;
      this.closed = !1;
      this.mc = new MessageChannel();
      this.name = e, Q[e] = Q[e] || [], Q[e].push(this), this.mc.port1.start(), this.mc.port2.start(), this.onStorage = this.onStorage.bind(this), window.addEventListener("storage", this.onStorage);
    }
    _createClass(Ae, [{
      key: "onStorage",
      value: function onStorage(e) {
        if (e.storageArea !== window.localStorage || e.key.substring(0, this.name.length) !== this.name || e.newValue === null) return;
        var r = JSON.parse(e.newValue);
        this.mc.port2.postMessage(r);
      }
    }, {
      key: "postMessage",
      value: function postMessage(e) {
        var _this2 = this;
        if (this.closed) throw new Error("InvalidStateError");
        var r = JSON.stringify(e),
          i = "".concat(this.name, ":").concat(String(Date.now())).concat(String(Math.random()));
        window.localStorage.setItem(i, r), I.setTimeout(function () {
          window.localStorage.removeItem(i);
        }, 500), Q[this.name].forEach(function (o) {
          o !== _this2 && o.mc.port2.postMessage(JSON.parse(r));
        });
      }
    }, {
      key: "close",
      value: function close() {
        if (this.closed) return;
        this.closed = !0, this.mc.port1.close(), this.mc.port2.close(), window.removeEventListener("storage", this.onStorage);
        var e = Q[this.name].indexOf(this);
        Q[this.name].splice(e, 1);
      }
    }, {
      key: "onmessage",
      get: function get() {
        return this.mc.port1.onmessage;
      },
      set: function set(e) {
        this.mc.port1.onmessage = e;
      }
    }, {
      key: "onmessageerror",
      get: function get() {
        return this.mc.port1.onmessageerror;
      },
      set: function set(e) {
        this.mc.port1.onmessageerror = e;
      }
    }, {
      key: "addEventListener",
      value: function addEventListener(e, r) {
        return this.mc.port1.addEventListener(e, r);
      }
    }, {
      key: "removeEventListener",
      value: function removeEventListener(e, r) {
        return this.mc.port1.removeEventListener(e, r);
      }
    }, {
      key: "dispatchEvent",
      value: function dispatchEvent(e) {
        return this.mc.port1.dispatchEvent(e);
      }
    }]);
    return Ae;
  }(),
  st = (typeof window === "undefined" ? "undefined" : _typeof(window)) > "u" ? void 0 : typeof window.BroadcastChannel == "function" ? window.BroadcastChannel : Ae;
function ot() {
  var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return new Promise(function (e) {
    return I.setTimeout(e, n);
  });
}
function Te() {
  return Math.random().toString(36).substring(2);
}
var Ie = /*#__PURE__*/function () {
  function Ie(e, r) {
    _classCallCheck(this, Ie);
    this.options = void 0;
    this.channel = void 0;
    this.token = Te();
    this.isLeader = !1;
    this.isDead = !1;
    this.isApplying = !1;
    this.reApply = !1;
    this.intervals = [];
    this.listeners = [];
    this.deferred = void 0;
    this.channel = e, this.options = r, this.apply = this.apply.bind(this), this.awaitLeadership = this.awaitLeadership.bind(this), this.sendAction = this.sendAction.bind(this);
  }
  _createClass(Ie, [{
    key: "apply",
    value: function () {
      var _apply = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this3 = this;
        var e, r;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(this.isLeader || this.isDead)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return", !1);
            case 2:
              if (!this.isApplying) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return", (this.reApply = !0, !1));
            case 4:
              this.isApplying = !0;
              e = !1, r = function r(i) {
                var _i$data = i.data,
                  o = _i$data.token,
                  u = _i$data.action;
                o !== _this3.token && (u === 0 && o > _this3.token && (e = !0), u === 1 && (e = !0));
              };
              this.channel.addEventListener("message", r);
              _context.prev = 7;
              this.sendAction(0);
              _context.next = 11;
              return ot(this.options.responseTime);
            case 11:
              this.channel.removeEventListener("message", r);
              this.isApplying = !1;
              return _context.abrupt("return", e ? this.reApply ? this.apply() : !1 : (this.assumeLead(), !0));
            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](7);
              return _context.abrupt("return", !1);
            case 19:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[7, 16]]);
      }));
      function apply() {
        return _apply.apply(this, arguments);
      }
      return apply;
    }()
  }, {
    key: "awaitLeadership",
    value: function awaitLeadership() {
      var _this4 = this;
      if (this.isLeader) return Promise.resolve();
      var e = !1,
        r = null;
      return new Promise(function (i) {
        var o = function o() {
          if (e) return;
          e = !0;
          try {
            I.clearInterval(r);
          } catch (_unused2) {}
          var g = _this4.intervals.indexOf(r);
          g >= 0 && _this4.intervals.splice(g, 1), _this4.channel.removeEventListener("message", u), i();
        };
        r = I.setInterval(function () {
          _this4.apply().then(function () {
            _this4.isLeader && o();
          });
        }, _this4.options.fallbackInterval), _this4.intervals.push(r);
        var u = function u(g) {
          var O = g.data.action;
          O === 2 && _this4.apply().then(function () {
            _this4.isLeader && o();
          });
        };
        _this4.channel.addEventListener("message", u);
      });
    }
  }, {
    key: "sendAction",
    value: function sendAction(e) {
      this.channel.postMessage({
        action: e,
        token: this.token
      });
    }
  }, {
    key: "assumeLead",
    value: function assumeLead() {
      var _this5 = this;
      this.isLeader = !0;
      var e = function e(r) {
        var i = r.data.action;
        i === 0 && _this5.sendAction(1);
      };
      return this.channel.addEventListener("message", e), this.listeners.push(e), this.sendAction(1);
    }
  }, {
    key: "waitForLeadership",
    value: function waitForLeadership() {
      return this.deferred ? this.deferred : (this.deferred = this.awaitLeadership(), this.deferred);
    }
  }, {
    key: "close",
    value: function close() {
      var _this6 = this;
      if (!this.isDead) {
        this.isDead = !0, this.isLeader = !1, this.sendAction(2);
        try {
          this.listeners.forEach(function (e) {
            return _this6.channel.removeEventListener("message", e);
          }), this.intervals.forEach(function (e) {
            return I.clearInterval(e);
          });
        } catch (_unused3) {}
      }
    }
  }]);
  return Ie;
}();
var Ee = /*#__PURE__*/function () {
  function Ee(e) {
    var _this7 = this;
    _classCallCheck(this, Ee);
    this.channel = void 0;
    this.options = void 0;
    this.elector = void 0;
    this.token = Te();
    this.registry = new Map();
    this.allIdle = !1;
    this.isLastActive = !1;
    var r = e.channelName;
    if (this.options = e, this.channel = new st(r), this.registry.set(this.token, 1), e.leaderElection) {
      var i = {
        fallbackInterval: 2e3,
        responseTime: 100
      };
      this.elector = new Ie(this.channel, i), this.elector.waitForLeadership();
    }
    this.channel.addEventListener("message", function (i) {
      var _i$data2 = i.data,
        o = _i$data2.action,
        u = _i$data2.token,
        g = _i$data2.data;
      switch (o) {
        case 3:
          _this7.registry.set(u, 2);
          break;
        case 4:
          _this7.registry["delete"](u);
          break;
        case 5:
          _this7.idle(u);
          break;
        case 6:
          _this7.active(u);
          break;
        case 7:
          _this7.prompt(u);
          break;
        case 8:
          _this7.start(u);
          break;
        case 9:
          _this7.reset(u);
          break;
        case 10:
          _this7.activate(u);
          break;
        case 11:
          _this7.pause(u);
          break;
        case 12:
          _this7.resume(u);
          break;
        case 13:
          _this7.options.onMessage(g);
          break;
      }
    }), this.send(3);
  }
  _createClass(Ee, [{
    key: "isLeader",
    get: function get() {
      if (!this.elector) throw new Error("\u274C Leader election is not enabled. To Enable it set the \"leaderElection\" property to true.");
      return this.elector.isLeader;
    }
  }, {
    key: "prompt",
    value: function prompt() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.token;
      this.registry.set(e, 0);
      var r = _toConsumableArray(this.registry.values()).every(function (i) {
        return i === 0;
      });
      e === this.token && this.send(7), r && this.options.onPrompt();
    }
  }, {
    key: "idle",
    value: function idle() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.token;
      this.registry.set(e, 2);
      var r = _toConsumableArray(this.registry.values()).every(function (i) {
        return i === 2;
      });
      e === this.token && this.send(5), !this.allIdle && r && (this.allIdle = !0, this.options.onIdle());
    }
  }, {
    key: "active",
    value: function active() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.token;
      this.allIdle = !1, this.registry.set(e, 1);
      var r = _toConsumableArray(this.registry.values()).some(function (i) {
        return i === 1;
      });
      e === this.token && this.send(6), r && this.options.onActive(), this.isLastActive = e === this.token;
    }
  }, {
    key: "start",
    value: function start() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.token;
      this.allIdle = !1, this.registry.set(e, 1), e === this.token ? this.send(8) : this.options.start(!0), this.isLastActive = e === this.token;
    }
  }, {
    key: "reset",
    value: function reset() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.token;
      this.allIdle = !1, this.registry.set(e, 1), e === this.token ? this.send(9) : this.options.reset(!0), this.isLastActive = e === this.token;
    }
  }, {
    key: "activate",
    value: function activate() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.token;
      this.allIdle = !1, this.registry.set(e, 1), e === this.token ? this.send(10) : this.options.activate(!0), this.isLastActive = e === this.token;
    }
  }, {
    key: "pause",
    value: function pause() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.token;
      e === this.token ? this.send(11) : this.options.pause(!0);
    }
  }, {
    key: "resume",
    value: function resume() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.token;
      e === this.token ? this.send(12) : this.options.resume(!0);
    }
  }, {
    key: "message",
    value: function message(e) {
      try {
        this.channel.postMessage({
          action: 13,
          token: this.token,
          data: e
        });
      } catch (_unused4) {}
    }
  }, {
    key: "send",
    value: function send(e) {
      try {
        this.channel.postMessage({
          action: e,
          token: this.token
        });
      } catch (_unused5) {}
    }
  }, {
    key: "close",
    value: function close() {
      this.options.leaderElection && this.elector.close(), this.send(4), this.channel.close();
    }
  }]);
  return Ee;
}();
var at = M ? document : null,
  xe = ["mousemove", "keydown", "wheel", "DOMMouseScroll", "mousewheel", "mousedown", "touchstart", "touchmove", "MSPointerDown", "MSPointerMove", "visibilitychange", "focus"];
function ct(n, e) {
  var r;
  function i() {
    for (var _len = arguments.length, o = new Array(_len), _key = 0; _key < _len; _key++) {
      o[_key] = arguments[_key];
    }
    r && clearTimeout(r), r = setTimeout(function () {
      n.apply(void 0, o), r = null;
    }, e);
  }
  return i.cancel = function () {
    clearTimeout(r);
  }, i;
}
function be(n, e) {
  var r = 0;
  return function () {
    var o = new Date().getTime();
    if (!(o - r < e)) return r = o, n.apply(void 0, arguments);
  };
}
var v = function v() {
  return Date.now();
};
var Z = 2147483647;
function se() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref2$timeout = _ref2.timeout,
    n = _ref2$timeout === void 0 ? 1e3 * 60 * 20 : _ref2$timeout,
    _ref2$promptTimeout = _ref2.promptTimeout,
    e = _ref2$promptTimeout === void 0 ? 0 : _ref2$promptTimeout,
    _ref2$promptBeforeIdl = _ref2.promptBeforeIdle,
    r = _ref2$promptBeforeIdl === void 0 ? 0 : _ref2$promptBeforeIdl,
    _ref2$element = _ref2.element,
    i = _ref2$element === void 0 ? at : _ref2$element,
    _ref2$events = _ref2.events,
    o = _ref2$events === void 0 ? xe : _ref2$events,
    _ref2$timers = _ref2.timers,
    u = _ref2$timers === void 0 ? void 0 : _ref2$timers,
    _ref2$immediateEvents = _ref2.immediateEvents,
    g = _ref2$immediateEvents === void 0 ? [] : _ref2$immediateEvents,
    _ref2$onPresenceChang = _ref2.onPresenceChange,
    O = _ref2$onPresenceChang === void 0 ? function () {} : _ref2$onPresenceChang,
    _ref2$onPrompt = _ref2.onPrompt,
    W = _ref2$onPrompt === void 0 ? function () {} : _ref2$onPrompt,
    _ref2$onIdle = _ref2.onIdle,
    m = _ref2$onIdle === void 0 ? function () {} : _ref2$onIdle,
    _ref2$onActive = _ref2.onActive,
    a = _ref2$onActive === void 0 ? function () {} : _ref2$onActive,
    _ref2$onAction = _ref2.onAction,
    d = _ref2$onAction === void 0 ? function () {} : _ref2$onAction,
    _ref2$onMessage = _ref2.onMessage,
    l = _ref2$onMessage === void 0 ? function () {} : _ref2$onMessage,
    _ref2$debounce = _ref2.debounce,
    p = _ref2$debounce === void 0 ? 0 : _ref2$debounce,
    _ref2$throttle = _ref2.throttle,
    f = _ref2$throttle === void 0 ? 0 : _ref2$throttle,
    _ref2$eventsThrottle = _ref2.eventsThrottle,
    B = _ref2$eventsThrottle === void 0 ? 200 : _ref2$eventsThrottle,
    _ref2$startOnMount = _ref2.startOnMount,
    y = _ref2$startOnMount === void 0 ? !0 : _ref2$startOnMount,
    _ref2$startManually = _ref2.startManually,
    D = _ref2$startManually === void 0 ? !1 : _ref2$startManually,
    _ref2$stopOnIdle = _ref2.stopOnIdle,
    ce = _ref2$stopOnIdle === void 0 ? !1 : _ref2$stopOnIdle,
    _ref2$crossTab = _ref2.crossTab,
    j = _ref2$crossTab === void 0 ? !1 : _ref2$crossTab,
    _ref2$name = _ref2.name,
    Oe = _ref2$name === void 0 ? "idle-timer" : _ref2$name,
    _ref2$syncTimers = _ref2.syncTimers,
    ee = _ref2$syncTimers === void 0 ? 0 : _ref2$syncTimers,
    _ref2$leaderElection = _ref2.leaderElection,
    Ce = _ref2$leaderElection === void 0 ? !1 : _ref2$leaderElection,
    _ref2$disabled = _ref2.disabled,
    C = _ref2$disabled === void 0 ? !1 : _ref2$disabled;
  var De = c(v()),
    ue = c(v()),
    w = c(null),
    R = c(null),
    F = c(0),
    te = c(0),
    N = c(0),
    S = c(0),
    h = c(!1),
    E = c(!1),
    H = c(!1),
    _ = c(!0),
    re = c(!1),
    U = c(null),
    s = c(null),
    k = c(n),
    G = c(0);
  b(function () {
    if (e && console.warn("\u26A0\uFE0F IdleTimer -- The `promptTimeout` property has been deprecated in favor of `promptBeforeIdle`. It will be removed in the next major release."), r && e) throw new Error("\u274C Both promptTimeout and promptBeforeIdle can not be set. The promptTimeout property will be deprecated in a future version.");
    if (n >= Z) throw new Error("\u274C The value for the timeout property must fit in a 32 bit signed integer, ".concat(Z, "."));
    if (e >= Z) throw new Error("\u274C The value for the promptTimeout property must fit in a 32 bit signed integer, ".concat(Z, "."));
    if (r >= Z) throw new Error("\u274C The value for the promptBeforeIdle property must fit in a 32 bit signed integer, ".concat(Z, "."));
    if (r >= n) throw new Error("\u274C The value for the promptBeforeIdle property must be less than the timeout property, ".concat(n, "."));
    if (r ? (k.current = n - r, G.current = r) : (k.current = n, G.current = e), !_.current) {
      if (D || C) return;
      h.current && (X.current(null, L), s.current && s.current.active()), J();
    }
  }, [n, e, r, D, C]);
  var Ne = c(ce);
  b(function () {
    Ne.current = ce;
  }, [ce]);
  var He = c(g),
    ne = c(i),
    ye = c(_toConsumableArray(new Set([].concat(_toConsumableArray(o), _toConsumableArray(g))).values())),
    A = c(C);
  b(function () {
    A.current = C, !_.current && (C ? fe() : D || J());
  }, [C]);
  var ie = c(O);
  b(function () {
    ie.current = O;
  }, [O]);
  var le = c(W);
  b(function () {
    le.current = W;
  }, [W]);
  var me = c(m);
  b(function () {
    me.current = m;
  }, [m]);
  var X = c(a);
  b(function () {
    X.current = a;
  }, [a]);
  var de = c(d);
  b(function () {
    de.current = d;
  }, [d]);
  var z = c(l);
  b(function () {
    z.current = l;
  }, [l]);
  var q = Dt(function () {
      var t = function t(P, K) {
        return de.current(P, K);
      };
      return p > 0 ? ct(t, p) : f > 0 ? be(t, f) : t;
    }, [f, p]),
    _e = c();
  b(function () {
    j && ee && (_e.current = be(function () {
      s.current.active();
    }, ee));
  }, [j, ee]);
  var x = function x() {
      U.current !== null && (I.clearTimeout(U.current), U.current = null);
    },
    $ = function $(t) {
      var P = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      x(), U.current = I.setTimeout(Le, t || k.current), P && (R.current = v());
    },
    Ue = function Ue(t) {
      !E.current && !h.current && (le.current(t, L), ie.current({
        type: "active",
        prompted: !0
      }, L)), S.current = 0, N.current = v(), E.current = !0, $(G.current, !1);
    },
    Fe = function Fe() {
      x(), h.current || (me.current(null, L), ie.current({
        type: "idle"
      }, L)), h.current = !0, w.current = v(), Ne.current ? Y() : E.current && (N.current = 0, E.current = !1);
    },
    we = function we(t) {
      x(), (h.current || E.current) && (X.current(t, L), ie.current({
        type: "active",
        prompted: !1
      }, L)), E.current = !1, N.current = 0, h.current = !1, F.current += v() - w.current, te.current += v() - w.current, V(), $();
    },
    Le = function Le(t) {
      if (!h.current) {
        q.cancel && q.cancel();
        var K = v() - R.current;
        if (!(k.current + G.current < K) && G.current > 0 && !E.current) {
          s.current ? s.current.prompt() : Ue(t);
          return;
        }
        s.current ? s.current.idle() : Fe();
        return;
      }
      s.current ? s.current.active() : we(t);
    },
    Pe = function Pe(t) {
      if (!y && !R.current && (R.current = v(), X.current(null, L)), q(t, L), E.current) return;
      if (x(), !h.current && He.current.includes(t.type)) {
        Le(t);
        return;
      }
      var P = v() - R.current;
      if (h.current && !ce || !h.current && P >= k.current) {
        Le(t);
        return;
      }
      H.current = !1, S.current = 0, N.current = 0, $(), j && ee && _e.current();
    },
    pe = c(Pe);
  b(function () {
    var t = re.current;
    t && Y(), B > 0 ? pe.current = be(Pe, B) : pe.current = Pe, t && V();
  }, [B, f, p, de, j, ee]);
  var V = function V() {
      M && ne.current && (re.current || (ye.current.forEach(function (t) {
        ne.current.addEventListener(t, pe.current, {
          capture: !0,
          passive: !0
        });
      }), re.current = !0));
    },
    Y = function Y() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      M && ne.current && (re.current || t) && (ye.current.forEach(function (P) {
        ne.current.removeEventListener(P, pe.current, {
          capture: !0
        });
      }), re.current = !1);
    },
    J = T(function (t) {
      return A.current ? !1 : (x(), V(), h.current = !1, E.current = !1, H.current = !1, S.current = 0, N.current = 0, s.current && !t && s.current.start(), $(), !0);
    }, [U, h, A, k, s]),
    Se = T(function (t) {
      return A.current ? !1 : (x(), V(), ue.current = v(), F.current += v() - w.current, te.current += v() - w.current, F.current = 0, h.current = !1, E.current = !1, H.current = !1, S.current = 0, N.current = 0, s.current && !t && s.current.reset(), D || $(), !0);
    }, [U, h, k, D, A, s]),
    Ve = T(function (t) {
      return A.current ? !1 : (x(), V(), (h.current || E.current) && we(), h.current = !1, E.current = !1, H.current = !1, S.current = 0, N.current = 0, ue.current = v(), s.current && !t && s.current.activate(), $(), !0);
    }, [U, h, E, A, k, s]),
    fe = T(function () {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      return A.current || H.current ? !1 : (S.current = We(), H.current = !0, Y(), x(), s.current && !t && s.current.pause(), !0);
    }, [U, A, s]),
    Me = T(function () {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      return A.current || !H.current ? !1 : (H.current = !1, E.current || V(), h.current || $(S.current), N.current && (N.current = v()), s.current && !t && s.current.resume(), !0);
    }, [U, k, A, S, s]),
    ut = T(function (t, P) {
      return s.current ? (P && z.current(t, L), s.current.message(t)) : P && z.current(t, L), !0;
    }, [l]),
    lt = T(function () {
      return h.current;
    }, [h]),
    mt = T(function () {
      return E.current;
    }, [E]),
    dt = T(function () {
      return s.current ? s.current.isLeader : null;
    }, [s]),
    pt = T(function () {
      return s.current ? s.current.isLastActive : null;
    }, [s]),
    ft = T(function () {
      return s.current ? s.current.token : null;
    }, [s]),
    We = T(function () {
      if (H.current) return S.current;
      var t = S.current ? S.current : G.current + k.current,
        P = R.current ? v() - R.current : 0,
        K = Math.floor(t - P);
      return K < 0 ? 0 : Math.abs(K);
    }, [k, G, E, S, R]),
    Be = T(function () {
      return Math.round(v() - ue.current);
    }, [ue]),
    Ge = T(function () {
      return Math.round(v() - De.current);
    }, [De]),
    ht = T(function () {
      return w.current ? new Date(w.current) : null;
    }, [w]),
    vt = T(function () {
      return R.current ? new Date(R.current) : null;
    }, [R]),
    qe = T(function () {
      return h.current ? Math.round(v() - w.current + F.current) : Math.round(F.current);
    }, [w, F]),
    $e = T(function () {
      return h.current ? Math.round(v() - w.current + te.current) : Math.round(te.current);
    }, [w, te]),
    Tt = T(function () {
      var t = Math.round(Be() - qe());
      return t >= 0 ? t : 0;
    }, [w, F]),
    It = T(function () {
      var t = Math.round(Ge() - $e());
      return t >= 0 ? t : 0;
    }, [w, F]);
  b(function () {
    if (p > 0 && f > 0) throw new Error("\u274C onAction can either be throttled or debounced, not both.");
    u && it(u);
    var t = function t() {
      s.current && s.current.close(), q.cancel && q.cancel(), x(), Y(!0);
    };
    return M && window.addEventListener("beforeunload", t), function () {
      M && window.removeEventListener("beforeunload", t), s.current && s.current.close(), q.cancel && q.cancel(), x(), Y(!0);
    };
  }, []), b(function () {
    s.current && s.current.close(), j ? s.current = new Ee({
      channelName: Oe,
      leaderElection: Ce,
      onPrompt: function onPrompt() {
        Ue();
      },
      onIdle: function onIdle() {
        Fe();
      },
      onActive: function onActive() {
        we();
      },
      onMessage: function onMessage(t) {
        z.current(t, L);
      },
      start: J,
      reset: Se,
      activate: Ve,
      pause: fe,
      resume: Me
    }) : s.current = null;
  }, [j, Oe, Ce, le, me, X, z, J, Se, fe, Me]), b(function () {
    _.current || (x(), Y(!0)), !(D || C) && (y ? J() : V());
  }, [D, y, C, _]), b(function () {
    if (!_.current) {
      var t = _toConsumableArray(new Set([].concat(_toConsumableArray(o), _toConsumableArray(g))).values());
      if (Y(), ye.current = t, ne.current = i, He.current = g, D || C) return;
      y ? J() : V();
    }
  }, [i, JSON.stringify(o), JSON.stringify(g), _, C, D, y]), b(function () {
    _.current && (_.current = !1);
  }, [_]);
  var L = {
    message: ut,
    start: J,
    reset: Se,
    activate: Ve,
    pause: fe,
    resume: Me,
    isIdle: lt,
    isPrompted: mt,
    isLeader: dt,
    isLastActiveTab: pt,
    getTabId: ft,
    getRemainingTime: We,
    getElapsedTime: Be,
    getTotalElapsedTime: Ge,
    getLastIdleTime: ht,
    getLastActiveTime: vt,
    getIdleTime: qe,
    getTotalIdleTime: $e,
    getActiveTime: Tt,
    getTotalActiveTime: It,
    setOnPresenceChange: function setOnPresenceChange(t) {
      O = t, ie.current = t;
    },
    setOnPrompt: function setOnPrompt(t) {
      W = t, le.current = t;
    },
    setOnIdle: function setOnIdle(t) {
      m = t, me.current = t;
    },
    setOnActive: function setOnActive(t) {
      a = t, X.current = t;
    },
    setOnAction: function setOnAction(t) {
      d = t, de.current = t;
    },
    setOnMessage: function setOnMessage(t) {
      l = t, z.current = t;
    }
  };
  return L;
}
import { createContext as Nt, useContext as Ht } from "react";
import { jsx as Vt } from "react/jsx-runtime";
var ge = /*#__PURE__*/Nt(null);
function _t(n) {
  var e = se(n);
  return Vt(ge.Provider, {
    value: e,
    children: n.children
  });
}
var Ut = ge.Consumer;
function Ft() {
  return Ht(ge);
}
export { xe as DEFAULT_EVENTS, ke as IdleTimerComponent, Ut as IdleTimerConsumer, ge as IdleTimerContext, _t as IdleTimerProvider, Ot as createMocks, se as useIdleTimer, Ft as useIdleTimerContext, kt as withIdleTimer, ae as workerTimers };